import Dream from "./components/Dream/Dream";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import HeroSection from "./components/HeroSection/HeroSection";
import Journey from "./components/Journey/Journey";
import Kings from "./components/Kings/Kings";
import Meme from "./components/Meme/Meme";

function App() {
  return (
    <>
      <Header />
      <HeroSection />
      <Meme />
      <Dream />
      <Journey />
      <Kings />
      <Footer />
    </>
  );
}

export default App;
